import Script from 'next/script';
import { useEffect } from 'react';
import type { Session } from 'next-auth';
import { getSignupContext } from '@/utils/signupContext';
import { GA_MEASUREMENT_ID, JOURNEY_TRACKING_ENABLED, sendGaEvent } from '@/utils/ga4';

const GoogleAnalytics = ({ session }: { session?: Session | null }) => {
  const journeyUserId = JOURNEY_TRACKING_ENABLED ? session?.user?.userId : null;
  const initialUserId = JSON.stringify(journeyUserId || null);

  useEffect(() => {
    getSignupContext('');
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;
    if (!session?.user?.created || !session.user.email) return;

    const key = `mynawoo_ga_signup:${session.user.email}`;
    if (localStorage.getItem(key)) return;

    const params = {
      signup_intent: session.user.signupIntent || 'learning',
      method: session.user.authProvider || 'unknown',
      ...(session.user.attribution || {}),
    };
    // The backend records the canonical signup row. Send only to GA here so
    // the internal journey database does not count one signup twice.
    sendGaEvent('signup_completed', params);
    localStorage.setItem(key, 'sent');
  }, [session?.user?.attribution, session?.user?.authProvider, session?.user?.created, session?.user?.email, session?.user?.signupIntent, session?.user?.userId]);

  if (process.env.NODE_ENV === 'development') return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="lazyOnload"
      />
      <Script id="mynawoo-google-analytics" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          window.gtag = window.gtag || gtag;
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', { user_id: ${initialUserId} });
        `}
      </Script>
    </>
  );
};

export default GoogleAnalytics;
